import Cookies from 'js-cookie';
import { atomFamily, useRecoilState } from 'recoil';
import { devError } from '../utils';
// this is needed to be able to share state between different components
// without constantly having to poll the cookies
const cookieRuntimeCache = atomFamily({
    key: '@zurich/common/hooks/cookieRuntimeCache',
    default: (key) => {
        // load the initial value from the cookie if available, otherwise return null
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = Cookies.get(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            devError(String(error));
            return null;
        }
    },
});
export function useCookie(key, initialValue) {
    const [storedValue, setStoredValue] = useRecoilState(cookieRuntimeCache(key));
    // set a value in the cookie and runtime cache
    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                Cookies.set(key, JSON.stringify(valueToStore), { path: '/' });
            }
        }
        catch (error) {
            devError(String(error));
        }
    };
    // here we handle the "null" returned from the runtime cache and return the initial value instead
    return [storedValue ?? initialValue, setValue];
}
